import RegisterBadgePage from './RegisterBadgePage';

export * from './types';

export default RegisterBadgePage;

